import { useEffect, useState } from "react";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { usePRD4011_R01Store } from "./Store_PRD4011_R01";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SysCodeDto, defaultSysCode_Modal } from "src/dtos/code/sysCodeDto";

/** SearchDropDownForm은 AnyDto(SysCodeDto 등)만 허용 — minorCd=값, codeNm=표시 */
const INTERVAL_OPTIONS: SysCodeDto[] = [
    { ...defaultSysCode_Modal, minorCd: "null", codeNm: "자동조회 OFF" },
    { ...defaultSysCode_Modal, minorCd: "1", codeNm: "1분" },
    { ...defaultSysCode_Modal, minorCd: "5", codeNm: "5분" },
    { ...defaultSysCode_Modal, minorCd: "10", codeNm: "10분" },
];

export const SearchSection_PRD4011_R01 = () => {
    const { PRD4011_R01Filter, setPRD4011_R01Filter, isPRD4011_R01Delayed } = usePRD4011_R01Store();
    const { compCdList } = useCommonCodeStore();
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({
        top: 0,
        left: 0,
    });

    useEffect(() => {
        if (!compCdList?.length) return;
        if (PRD4011_R01Filter.compCd) return;
        const first = compCdList[0];
        if (first?.compCd) {
            setPRD4011_R01Filter({ compCd: first.compCd });
        }
    }, [compCdList, PRD4011_R01Filter.compCd, setPRD4011_R01Filter]);

    return (
        <SearchSectionForm>
            <SearchDropDownForm<CompanyDto>
                label="사업장"
                value={PRD4011_R01Filter.compCd}
                optionList={compCdList}
                initLabelLess
                onChangeValue={(v) => setPRD4011_R01Filter({ compCd: v })}
            />
            <SearchDateSingleForm
                label="작업일자"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                value={PRD4011_R01Filter.searchDate}
                onChange={(date) => setPRD4011_R01Filter({ searchDate: date })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
            <SearchDropDownForm<SysCodeDto>
                label="자동조회"
                value={PRD4011_R01Filter.autoRefreshInterval?.toString() ?? "null"}
                optionList={INTERVAL_OPTIONS}
                onChangeValue={(v) =>
                    setPRD4011_R01Filter({
                        autoRefreshInterval:
                            v === "null" || v === "" || v === defaultSysCode_Modal.minorCd
                                ? null
                                : Number(v),
                    })
                }
            />
            {isPRD4011_R01Delayed && (
                <div className="ml-4 flex items-center gap-2 px-3 py-1 bg-[#fdeaea] border border-[#f3c4c6] rounded-md text-[#a51d24] text-[14px] font-bold">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 3 2 21h20L12 3z" />
                        <path d="M12 10v5" />
                        <path d="M12 18h.01" />
                    </svg>
                    <span>최종 모니터링 정보가 1시간 이상 지연되었습니다. 데이타수집 상태를 확인하세요.</span>
                </div>
            )}
        </SearchSectionForm>
    );
};
